import { createQueryKeys } from "@lukemorales/query-key-factory";
import { QueryProps } from "@/api/api";
import { LineChartResponse } from "@/components/charts/lineChartResponse";
import { AUTO } from "@/dateRanges/windowSizes";
import { getAutoWindowSize } from "@/dateRanges/DateRangeContext";
import { apiClient } from "@/api/client";

export const lineCharts = createQueryKeys('charts', {
  detail: (
    apiPath: string, query: QueryProps,
  ) => ({
    queryKey: [apiPath, query],
    queryFn: async () => {
      const { dateRange, windowSize, ...otherQueryProps } = query

      const start = dateRange.value.from()
      const stop = dateRange.value.to()
      const window_size = windowSize === AUTO ? getAutoWindowSize(dateRange).value : windowSize.value;

      const response = await apiClient.post<LineChartResponse>(
        apiPath,
        {
          ...otherQueryProps,
          window_size,
          start,
          stop,
          timezone_for_bucketing: Intl.DateTimeFormat().resolvedOptions().timeZone
        }
      );
      return response.data;
    }
  })
});
